import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { EntityState } from '@ngrx/entity';
import { IRegistrantDetails } from 'src/app/models/registration/registrantDetails';

export interface IRegistrantsState extends EntityState<IRegistrantDetails> {
    failText: string | null;
}

export const registrantAdapter: EntityAdapter<IRegistrantDetails> = createEntityAdapter<IRegistrantDetails>({
    selectId: (i: IRegistrantDetails) => i.entityId
});

export const initialRegistrantsState: IRegistrantsState = registrantAdapter.getInitialState({
    failText: null
});
